var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Stock } from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.stock = [];
        this.set = function (stock) {
            _this.stock = stock.map(function (customer) { return new Stock(customer); });
        };
    }
    default_1.prototype.read = function (article) {
        if (article)
            return api
                .get("stock?article=".concat(article))
                .then(function (stock) { return stock.map(function (s) { return new Stock(s); }); });
        return api.get('stock').then(this.set);
    };
    default_1.prototype.create = function (inventory) {
        var _this = this;
        return api
            .post('inventory', inventory)
            .then(function () { return _this.read(inventory.article); });
    };
    __decorate([
        observable
    ], default_1.prototype, "stock", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stock/Store.ts
// module id = 695
// module chunks = 0